<div class="p-24 m-0" fusePerfectScrollbar style="padding-bottom:0px !important;">
    <form [formGroup]="formGroup" novalidate>
        <div fxLayout="row" fxLayoutAlign="start start">

            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                        <!-- <input type="text" placeholder="{{translations.cmbDistributor}}" 
                        matInput #textInput [formControl]="searchTerm" required [matAutocomplete]="auto"> -->
                        <!-- <mat-progress-bar class="Autocomplete__progressbar" [mode]="'indeterminate'" [hidden]="!IS_LOADING"></mat-progress-bar> -->
                        <!-- <mat-autocomplete #auto="matAutocomplete"  required>
                            <ngx-mat-select-search [formControl]="parentFilterControl"></ngx-mat-select-search>
                            <mat-option *ngFor="let item of searchResult" [value]="item.Name" (onSelectionChange)="onDistSelect(item.Id)">
                            {{ item.Name }}
                            </mat-option>
                        </mat-autocomplete> -->

                <mat-select placeholder="{{translations.cmbDistributor}}"  
                [(ngModel)]="parent.order.D_DistributorId" formControlName="D_DistributorId" 
                    required >
                    <mat-option *ngFor="let distributr of distributorList" [value]="distributr.Id">{{distributr.Name}} ({{distributr.Code}})</mat-option>
                </mat-select>
                <mat-error *ngIf="formGroupErrors.D_DistributorId.required">
                    {{translations.msgPleaseSelectDistributor}}
                </mat-error>
            </mat-form-field>
            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput type="number" min="1" max="53" placeholder="{{translations.txtDeliveryWeek}}"
                 formControlName="D_DeliveryWeek"
                    [(ngModel)]="parent.order.D_DeliveryWeek" required maxlength="2">
                <mat-error *ngIf="formGroupErrors.D_DeliveryWeek.required">
                    {{translations.msgPleaseEnterDeliveryWeek}}
                </mat-error>
                <mat-error *ngIf="formGroupErrors.D_DeliveryWeek.min">
                    {{translations.msgPleaseEnterValidWeek}}
                </mat-error>
                <mat-error *ngIf="formGroupErrors.D_DeliveryWeek.max">
                    {{translations.msgPleaseEnterValidWeek}}
                </mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start start">
            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput [matDatepicker]="dp3" placeholder="{{translations.txtShippingDate}}" formControlName="D_ShipDate" [(ngModel)]="parent.order.D_ShipDate"
                    readonly>
                <mat-icon *ngIf="parent.order.D_ShipDate" matSuffix (click)="parent.order.D_ShipDate = ''" style="font-size: 15px;cursor: pointer;">close</mat-icon>
                <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                <mat-datepicker #dp3 disabled="false"></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput placeholder="{{translations.txtShippingWeek}}" formControlName="D_SheepWeek" [(ngModel)]="parent.order.D_SheepWeek"
                    type="number" min="1" max="53" [value]="appService.ISO8601_week_no(parent.order.D_ShipDate)">
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start start">
            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput placeholder="{{translations.txtLicensePlate}}" formControlName="D_LicensePlate" [(ngModel)]="parent.order.D_LicensePlate"
                    maxlength="50">
            </mat-form-field>
            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput placeholder="{{translations.txtT2No}}" formControlName="D_T2No" [(ngModel)]="parent.order.D_T2No" maxlength="50">
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start start">
            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput [matDatepicker]="dp4" placeholder="{{translations.txtReceiveDate}}" formControlName="D_ReceiveDate" [(ngModel)]="parent.order.D_ReceiveDate"
                    readonly>
                    <mat-icon *ngIf="parent.order.D_ReceiveDate" matSuffix (click)="parent.order.D_ReceiveDate = ''" style="font-size: 15px;cursor: pointer;">close</mat-icon>
                <mat-datepicker-toggle matSuffix [for]="dp4"></mat-datepicker-toggle>
                <mat-datepicker #dp4 disabled="false"></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput placeholder="{{translations.txtReceiveWeek}}" formControlName="D_ReceiveWeek" [(ngModel)]="parent.order.D_ReceiveWeek"
                    type="number" min="1" max="53" [value]="appService.ISO8601_week_no(parent.order.D_ReceiveDate)">
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start start">
            <!-- <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput placeholder="{{translations.txtRemark}} " formControlName="D_Remark" [(ngModel)]="parent.order.D_Remark"
                    maxlength="100">
            </mat-form-field> -->
            <!-- <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput placeholder="{{translations.txtPlannedDate}}" formControlName="D_PlannedDate" [(ngModel)]="parent.order.D_PlannedDate"
                    maxlength="100">
            </mat-form-field> -->
            <mat-form-field class="mr-24 single-field" fxFlex.xs="100" fxFlex="50" style="max-width: 48% !important;">
                <input matInput [matDatepicker]="dp5" placeholder="{{translations.txtPlannedDate}}" formControlName="D_PlannedDate" [(ngModel)]="parent.order.D_PlannedDate">
<!--                    <mat-icon *ngIf="parent.order.D_PlannedDate" matSuffix (click)="parent.order.D_PlannedDate = ''" style="font-size: 15px;cursor: pointer;">close</mat-icon>-->
<!--                <mat-datepicker-toggle matSuffix [for]="dp5"></mat-datepicker-toggle>-->
                <mat-datepicker #dp5 disabled="true"></mat-datepicker>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start start">
            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput [matDatepicker]="dp6" placeholder="{{translations.txtActualDate}}" formControlName="D_ActualDate" [(ngModel)]="parent.order.D_ActualDate">
<!--
                    <mat-icon *ngIf="parent.order.D_ActualDate" matSuffix (click)="parent.order.D_ActualDate = ''" style="font-size: 15px;cursor: pointer;">close</mat-icon>
                <mat-datepicker-toggle matSuffix [for]="dp6"></mat-datepicker-toggle>
-->
                <mat-datepicker #dp6 disabled="true"></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput placeholder="{{translations.txtActualWeek}}" formControlName="D_ActualWeek" [(ngModel)]="parent.order.D_ActualWeek"
                    type="number" min="1" max="53" [value]="appService.ISO8601_week_no(parent.order.D_ActualDate)">
            </mat-form-field>
        </div>
    </form>

</div>


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order/order-edit-form/delivery-detail/delivery-detail.component.html